import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { reaction } from 'mobx';

import { routeNaming, AppRedirect } from '../../routes';
import { HomeNavbar } from '../../common/home-navbar';
import { Footer } from '../../common/footer';
import { Spinner } from '../../common/spinner';
import { ProductStore } from './stores/ProductStore';
import { MainBody } from './main-body';
import styles from './ProductDetail.css';
import { CompareSection } from '../../common/compare-section/CompareSection';
import { GA4 } from '../../helpers/GA4';

const IPropTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

class ProductDetail extends React.Component {
  constructor(props) {
    super(props);
    this.productId = null;
  }

  componentDidMount() {
    const productId = this.props.match.params.id;
    this.productId = productId;
    ProductStore.fetchProduct(productId);
    this.disposer = reaction(
      () => ProductStore.product,
      (newProduct) => {
        if (!newProduct) {
          return;
        }
        GA4.viewItemEvent(
          ProductStore.product.financing && ProductStore.product.financing.price,
          {
            item_id: ProductStore.product.id,
            item_name: ProductStore.product.name.trim(),
            price: ProductStore.product.financing && ProductStore.product.financing.price,
          },
        );
      },
    );
  }

  componentDidUpdate() {
    if (this.productId !== this.props.match.params.id) {
      this.productId = this.props.match.params.id;
      ProductStore.fetchProduct(this.productId);
    }
  }

  componentWillUnmount() {
    ProductStore.clearError();
  }

  render() {
    const dataLoaded = ProductStore.product !== null;
    return (
      <div className={[styles.container, dataLoaded ? styles.dataLoaded : ''].join(' ')}>
        <HomeNavbar />
        <CompareSection />
        {
          ProductStore.error &&
          <AppRedirect routeName={routeNaming.HOME} />
        }
        {
          dataLoaded
            ? <MainBody />
            : <Spinner className={styles.spinner} />
        }
        <Footer />
      </div>
    );
  }
}

ProductDetail.propTypes = IPropTypes;

const ProductDetailWrapper = observer(ProductDetail);

export { ProductDetailWrapper as ProductDetail };



// WEBPACK FOOTER //
// ./src/pages/product-detail/ProductDetail.jsx